import { createApp } from 'vue'
import AddCohortWizard from '../components/add_cohort_wizard.vue'

const safeRegisterElement = (name, element, options = {}) => !window.customElements.get(name) && window.customElements.define(name, element, options)

safeRegisterElement('add-cohort-wizard', class extends HTMLElement {
  connectedCallback () {
    this.appElem = document.createElement('div')

    let setaQualifications = null
    try {
      if (this.dataset.setaQualifications) {
        setaQualifications = JSON.parse(this.dataset.setaQualifications)
      }
    } catch (e) {
      console.error('Failed to parse setaQualifications:', e)
    }

    this.app = createApp(AddCohortWizard, {
      setaQualifications,
      onClose: () => {
        this.remove()
      }
    })

    this.app.mount(this.appElem)
    this.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()
  }
})
